// frontend/src/components/ProfileBlockEditors/StatsBlockEditor.js
import React from 'react';
import { PlusIcon, DeleteIcon } from '../Icons';

const StatsBlockEditor = ({ block, onChange }) => {
    const handleTitleChange = (title) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                title
            }
        });
    };

    const handleAddStat = () => {
        const items = block.content?.items || [];
        onChange({
            ...block,
            content: {
                ...block.content,
                title: block.content?.title || '',
                items: [...items, { label: '', value: '' }]
            }
        });
    };

    const handleRemoveStat = (index) => {
        const items = block.content?.items || [];
        onChange({
            ...block,
            content: {
                ...block.content,
                items: items.filter((_, i) => i !== index)
            }
        });
    };

    const handleStatChange = (index, field, value) => {
        const items = [...(block.content?.items || [])];
        items[index] = {
            ...items[index],
            [field]: value
        };
        onChange({
            ...block,
            content: {
                ...block.content,
                items
            }
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Titel
                </label>
                <input
                    type="text"
                    value={block.content?.title || ''}
                    onChange={(e) => handleTitleChange(e.target.value)}
                    placeholder="z.B. Zahlen und Fakten"
                    className="md3-textfield-outlined w-full"
                />
            </div>

            <div>
                <div className="flex justify-between items-center mb-2">
                    <span className="text-label-large font-bold text-surface-onVariant">Statistiken</span>
                    <button
                        onClick={handleAddStat}
                        className="md3-btn-text text-sm h-8"
                    >
                        <PlusIcon fontSize="small" className="mr-1" /> Hinzufügen
                    </button>
                </div>

                <div className="flex flex-col gap-2">
                    {(block.content?.items || []).map((item, index) => (
                        <div key={index} className="flex items-center gap-2 p-3 bg-surface-container rounded-lg border border-divider">
                            <div className="flex-1">
                                <label className="block text-label-small text-surface-onVariant mb-1">Label</label>
                                <input
                                    type="text"
                                    value={item.label}
                                    onChange={(e) => handleStatChange(index, 'label', e.target.value)}
                                    placeholder="z.B. Lager"
                                    className="md3-textfield-outlined w-full h-10 px-3 py-2 text-body-medium"
                                />
                            </div>
                            <div className="w-1/3">
                                <label className="block text-label-small text-surface-onVariant mb-1">Wert</label>
                                <input
                                    type="text"
                                    value={item.value}
                                    onChange={(e) => handleStatChange(index, 'value', e.target.value)}
                                    placeholder="z.B. 5"
                                    className="md3-textfield-outlined w-full h-10 px-3 py-2 text-body-medium"
                                />
                            </div>
                            <div className="pt-5">
                                <button
                                    onClick={() => handleRemoveStat(index)}
                                    className="md3-icon-btn text-error hover:bg-error-container hover:text-error-on-container w-8 h-8"
                                    title="Entfernen"
                                >
                                    <DeleteIcon fontSize="small" />
                                </button>
                            </div>
                        </div>
                    ))}

                    {(block.content?.items || []).length === 0 && (
                        <div className="text-center py-4 bg-surface-containerLow rounded-lg border border-dashed border-outlineVariant text-body-small text-surface-onVariant">
                            Keine Statistiken vorhanden. Füge welche hinzu.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatsBlockEditor;
